import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '@navent-re/global-styled';

const maxContainer = {
  mobile: '540px',
  tablet: '960px',
  desktop: '1280px',
  full: '1540px'
};

const ThisLayoutContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  @media (min-width: 1180px) {
    padding: 0 80px;
  }
  ${({ isFullViewport, ignoreLargeDesktop }) =>
    !isFullViewport &&
    ` 
	/* Si es vista mapa directamente no pongo breakpoint porque siempre es 100% */

		@media ${media.mobile} {
			max-width: 100%;
            display: flex;
            flex-direction: row;
		}
		@media ${media.tablet} {
			max-width: ${maxContainer.tablet};
			padding: 0 40px;
		}
    
		@media ${media.desktop} {
			max-width: ${maxContainer.desktop};
		}
		@media ${media.largeDesktop} {
			/* Si es vista mosaico ponemos el ancho de desktop normal para todo */
			max-width: ${ignoreLargeDesktop ? maxContainer.desktop : maxContainer.full};
			padding: 0 10px;
		}
	
	`}

  ${props => props.extend && props.extend}
`;

const LayoutContainer = props => {
  const { isFullViewport = false, ignoreLargeDesktop = false, extend, children } = props;

  return (
    <ThisLayoutContainer
      data-panel='landingZD-footer-bottonFooter-layoutContainer'
      extend={extend}
      isFullViewport={isFullViewport}
      ignoreLargeDesktop={ignoreLargeDesktop}
    >
      {children}
    </ThisLayoutContainer>
  );
};

export default LayoutContainer;
